import React, { useState, useEffect } from 'react';
import { useHistory } from "react-router-dom";
import UserMenu from './UserMenu';
import Sidebar from './Sidebar';
import Box from './Box';
import Toast from './Toast';
import axios from 'axios';

const Reports = (props) => {

    const history = useHistory();

    const [data, setData] = useState({});
    const [toastRef, setToastRef] = useState(React.createRef());
    const [companies, setCompanies] = useState([]);
    const [error, setError] = useState(false);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!sessionStorage.getItem('sessionData')) {
            history.push('/login');
        } else {
            
            //get companies
            //setLoading(true);
            axios.get(`${process.env.REACT_APP_URI_API_CRM}/companies`, {
                params: {}
            })
            .then(function (response) {
                setCompanies(response.data);
                //setLoading(false);
            })
            .catch(function (error) {
                console.log("Error:", error.message);
                setError(error.message);
                //setLoading(false);
            });
        }
    }, []);

    const handleChange = (event) => {
        setData({ ...data, [event.target.name]: event.target.value })
    }

    const handleCalendar = (dateValue, fieldName) => {
        setData({ ...data, [fieldName]: dateValue.toISOString() })
    }

    const getDailyTaskReport=()=>{
        let currentSessionData = JSON.parse(sessionStorage.getItem('sessionData')); 

        const options = {
            url: `${process.env.REACT_APP_URI_API_CRM}/daily_tasks`,
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json;charset=UTF-8',
                'Authorization': currentSessionData.token,
            },
            params: data
        };

        setLoading(true);
        axios(options).then(response => {
            setLoading(false);
            let csv = 'data:text/csv;charset=utf-8,' + response.data;
            let csvData = encodeURI(csv);
            window.open(csvData);
        });
    }

    return (
        <div className="mainWrapper">
            <Toast ref={toastRef}></Toast>
            <Sidebar key={props.inboundConnectedQueues} />
            

            <div className="main">
                <div className="headerWrapper">
                    <div className="titleWrapper">
                        <h1>Registro de Pagos</h1>
                        <span className="upper">Reportes</span>
                    </div>
                    <div className="flexWrapper"> 
                        <UserMenu />
                    </div>
                </div>

                <h3>Reporte gestiones diarias</h3>
                <div className="flexRow">
                    <div className="flexCol">
                        <Box type="select" name="companyId" className="x2" label="Empresa" placeholder="Seleccione ..." options={companies} onChange={handleChange} required></Box>
                        <Box type="calendar" name="reportDate" className="x2" label="Día" selectedDate={data.reportDate} onChange={(e) => handleCalendar(e, 'reportDate')} withoutLimits={true} required></Box>
                    </div>
                </div>
                <button className={loading ? 'default loading' : 'default'} onClick={getDailyTaskReport}>Generar reporte</button>
                
                <div><p className="debug">data:{JSON.stringify(data)}</p></div>
                
            </div>
            
        </div>
        
    );
    
}

export default Reports;





    